import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import StatusBadge from "@/components/StatusBadge";
import { ArrowsClockwise, Calendar, Clock, MapPin } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Swaps() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/swaps/available").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const accept = async (id) => {
    if (!window.confirm("Take over this shift?")) return;
    try { await api.post(`/bookings/${id}/accept-swap`); toast.success("Shift taken over!"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not accept"); }
  };
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <ArrowsClockwise size={28} className="text-blue-600" />
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Shift swaps</h1>
      </div>
      <p className="text-slate-600">Pick up shifts that other verified workers can no longer do.</p>
      {items.length === 0 && <div className="card-tactile p-8 text-center text-slate-500">No swaps available right now.</div>}
      <div className="space-y-3">
        {items.map((b) => (
          <div key={b.id} className="card-tactile p-5" data-testid={`swap-${b.id}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div>
                <div className="font-display text-lg font-bold text-slate-900">{b.job?.title}</div>
                <div className="text-sm text-slate-600">{b.job?.company_name}</div>
                <div className="mt-1 flex flex-wrap gap-3 text-sm text-slate-700">
                  <span className="flex items-center gap-1.5"><Calendar size={14}/>{b.job_date}</span>
                  <span className="flex items-center gap-1.5"><Clock size={14}/>{b.start_time}–{b.end_time}</span>
                  <span className="flex items-center gap-1.5"><MapPin size={14}/>{b.job?.location}</span>
                </div>
                {b.swap_reason && <div className="text-xs text-slate-500 mt-1 italic">"{b.swap_reason}"</div>}
              </div>
              <div className="text-right">
                <StatusBadge status="swap offered" />
                <div className="mt-1 font-display text-lg font-extrabold">£{b.net_amount}</div>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-slate-100">
              <Button data-testid={`swap-accept-${b.id}`} onClick={()=>accept(b.id)} className="bg-blue-600 hover:bg-blue-700">Take this shift</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
